import Signup from "../Auth/components/Signup";

function SignupPage() {
    return (
        <>
         <div>
            <Signup/>
         </div>
        </>
    );
}

export default SignupPage;